'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import {
  SecondaryTabProvider,
  SecondaryTabs,
  SecondaryTabsContent,
  SecondaryTabsList,
  SecondaryTabsTrigger,
} from '@/components/ui/secondary-tab.component';
import { useScheduleTab } from '@/app/(main)/(pages)/busca/[slug]/_hooks/use-schedule-tab.hook';
import { SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { ScheduleTabContent } from '@/app/(main)/(pages)/busca/[slug]/_components/search-schedules-list/search-card/_components/tabs/schedule-tab-content.component';

interface SearchCardClinicTabsProps {
  schedule: SearchPartnerData;
}

export function SearchCardClinicTabs({ schedule }: SearchCardClinicTabsProps) {
  const { tabs, selectedTab, onValueChange } = useScheduleTab(schedule);

  if (tabs.length === 0) {
    return null;
  }

  const defaultValue = tabs[0].key;
  const tabsKey = tabs.map((tab) => tab.key).join('-');

  return (
    <SecondaryTabProvider>
      <SecondaryTabs
        key={tabsKey}
        defaultValue={defaultValue}
        value={selectedTab}
        className="w-full flex flex-col gap-3"
        data-testid={DataTestIdEnum.SEARCH_CARD_CLINIC_TABS}
        onValueChange={onValueChange}
      >
        <SecondaryTabsList className="z-auto">
          {tabs.map((tab) => (
            <SecondaryTabsTrigger
              key={tab.key}
              value={tab.key}
              className="min-w-0 text-sm xl:text-base leading-5 xl:leading-6 pb-1 px-4 break-words"
              data-testid={`${DataTestIdEnum.SEARCH_CARD_CLINIC_TAB_TRIGGER}-${tab.key.toLowerCase()}`}
            >
              {tab.title}
            </SecondaryTabsTrigger>
          ))}
        </SecondaryTabsList>

        {tabs.map((tab) => (
          <SecondaryTabsContent key={tab.key} value={tab.key}>
            <ScheduleTabContent tabKey={tab.key} schedule={schedule} />
          </SecondaryTabsContent>
        ))}
      </SecondaryTabs>
    </SecondaryTabProvider>
  );
}
